import { render, staticRenderFns } from "./TransferDebtorDetail.vue?vue&type=template&id=e4b4de70&scoped=true&"
import script from "./TransferDebtorDetail.vue?vue&type=script&lang=js&"
export * from "./TransferDebtorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b4de70",
  null
  
)

export default component.exports